import { render, staticRenderFns } from "./ActividadReciente.vue?vue&type=template&id=2758d72a&"
import script from "./ActividadReciente.vue?vue&type=script&lang=js&"
export * from "./ActividadReciente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports